import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

function ListBlock({ items }) {
  if (!items?.length) return <p className="text-[13px] text-slate-400">—</p>;
  return (
    <ul className="list-disc pl-5 space-y-1 text-[13px] text-slate-700">
      {items.map((t, i) => <li key={i}>{t}</li>)}
    </ul>
  );
}

/** Divulgación progresiva de la guía del paso en lenguaje llano. */
export default function StepGuidance({ guidance }) {
  if (!guidance) return null;
  const sections = [
    { key: "inputs", title: "Qué necesitas tener a mano", items: guidance.inputs_needed },
    { key: "steps", title: "Cómo hacerlo paso a paso", items: guidance.concrete_steps },
    { key: "mistakes", title: "Errores típicos", items: guidance.common_mistakes },
    { key: "done", title: "Cuándo puedes darlo por hecho", items: guidance.definition_of_done },
  ].filter((s) => s.items?.length);

  return (
    <div className="mt-4" data-testid="step-guidance">
      <Accordion type="multiple" className="bg-white border border-slate-200 rounded-md px-4">
        {sections.map((s) => (
          <AccordionItem key={s.key} value={s.key} data-testid={`guidance-${s.key}`}>
            <AccordionTrigger className="text-[14px] text-slate-800">{s.title}</AccordionTrigger>
            <AccordionContent><ListBlock items={s.items} /></AccordionContent>
          </AccordionItem>
        ))}
        {guidance.auditor_lens && (
          <AccordionItem value="auditor" data-testid="guidance-auditor">
            <AccordionTrigger className="text-[14px] text-slate-800">Qué mirará el auditor</AccordionTrigger>
            <AccordionContent><p className="text-[13px] text-slate-700">{guidance.auditor_lens}</p></AccordionContent>
          </AccordionItem>
        )}
      </Accordion>
    </div>
  );
}
